import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  DetailsImages,
  DetailsModel,
  HomeContentItem,
  SearchArticles,
  SearchModel,
} from "../model/HomeModel";
import { HomeServices } from "../service/Service";

export interface CounterState {
  // 首页
  value: number;
  banner: string[];
  content: HomeContentItem[][];
  content_m: HomeContentItem[][];
  homeNews:object[];
  // 搜索
  searchArticles: SearchArticles[];
  // 详情页数据
  detailsContent: string;
  detailsContent_m: string;
  detailsImgs: DetailsImages[];
}

const initialState: CounterState = {
  // 首页
  value: 0,
  banner: [],
  content: [],
  content_m: [],
  // 搜索
  searchArticles: [],

  detailsContent: "",
  detailsContent_m: "",
  detailsImgs: [],
  homeNews: []
};

export const homeAsync = createAsyncThunk("home/getHomeData", async () => {
  const response = await HomeServices.index();
  return response.data;
});

export const searchAsync = createAsyncThunk(
  "search/getSearchData",
  async (keyword: string) => {
    const response = await HomeServices.search(keyword);
    return response.data as SearchModel;
  }
);

export const detailsAsync = createAsyncThunk(
  "details/getDetailsData",
  async ({
    url,
    uuid,
    methods,
    video,
    memberImg,
    memberName,
    pdf,
    education,
    postion,
    info,
    newstime
  }: {
    url: string;
    uuid: string;
    methods: "get" | "post";
    video?:string;
    memberImg?:any;
    memberName?:any;
    pdf?:string;
    education?:string;
    postion?:any
    info?:object
    newstime?:string
  }) => {
    const response = await HomeServices.details({ uuid, url, methods });

    return response.data as DetailsModel;
  }
);

export const HomeStore = createSlice({
  name: "home",
  initialState,
  reducers: {
    sum: (state, action: PayloadAction<number>) => {
      state.value += action.payload;
    },
    resetSearchArticles: (state) => {
      state.searchArticles = [];
    },
    setDetails: (state) => {
      state.detailsContent = "";
      state.detailsImgs = [];
    },
  },
  extraReducers: (builder) => {
    // 首页数据
    builder.addCase(homeAsync.fulfilled, (state, action) => {
      state.banner =
        (action.payload.top &&
          action.payload.top.length > 0 &&
          action.payload.top[0].pic &&
          action.payload.top[0].pic.split(";")) ||
        [];
      state.content =
        (action.payload.content &&
          action.payload.content.length > 0 &&
          action.payload.content) ||
        [];
        state.content_m =
        (action.payload.content_m &&
          action.payload.content_m.length > 0 &&
          action.payload.content_m) ||
        [];
        state.homeNews=
        (action.payload.news) ||{};
    });
    // 搜索页数据
    builder.addCase(searchAsync.fulfilled, (state, action) => {
      state.searchArticles =
        (action.payload &&
          action.payload.articles &&
          action.payload.articles.length > 0 &&
          action.payload.articles) ||
        [];
    });

    // 详情页数据
    builder.addCase(detailsAsync.fulfilled, (state, action) => {
      state.detailsContent =
        (action.payload && action.payload.content) ||
        (action.payload && action.payload.introduction) ||
        "";
        
      state.detailsContent_m =
        (action.payload && action.payload.introduction_m) || "";
      // console.log(state);
      
      state.detailsImgs =
        (action.payload &&
          action.payload.img &&
          action.payload.img.length > 0 &&
          action.payload.img) ||
        [];
    });
  },
});

export const { sum, resetSearchArticles, setDetails } = HomeStore.actions;

export default HomeStore.reducer;
function detailsContent(detailsContent: any) {
  throw new Error("Function not implemented.");
}

